import React from 'react'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import SBheader from '../components/SBheader'
import SBnewFooter from '../components/SBnewFooter'
import SBsimpleModal from '../components/SBsimpleModal'
import { SSS_CONTENTS } from "../helpers/statics"
import { Field, Select2, Checkbox } from '../components/forms'
import { Frap } from '../components/button'
import { getLocale} from "../helpers/stateFunctions"
import { TEXTS } from "../helpers/statics"
import { isNumericOrEmpty, isValidEmail } from '../helpers/utility'
import _ from 'lodash'
import { getContactForm, submitContactForm } from '../helpers/rioHelper'

class Contact extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showThanksModal: false,
      phoneNumber: "",
      selectedQuestionIndex: "",
      selectedContentId: "",
      searchTerm: "",
      searchResults: [],
      contactForm:{}
    }
  }

  state = {
    mainCategory: "",
    subCategory: "",
    selectedQuestionIndex: ""
  }

  async componentDidMount() {
    try{
        let contactForm = await getContactForm()
        this.setState({contactForm:contactForm.data.result})
    }
    catch{

    }
    
    this.clearState()
    if (this.props.user.user) {
      this.autoFillUser()
    } else {
      setTimeout(() => { this.autoFillUser() }, 2000)
    }
  }

  autoFillUser() {
    if (this.props.user.user) {
      let user = { ...this.props.user.user }
      let { firstName, lastName, email, phoneNumber } = user
      this.setState({ firstName, lastName, email, phoneNumber })
    }
  }

  clearState() {
    this.setState({ mainCategory: "", subCategory: "", message: "", cboxAccepted: false, loadingSend: false })
    if(!this.props.user || !this.props.user.user){
      this.setState({ firstName: "", lastName: "", email: "", phoneNumber: "90"})
    }
  }

  handleFormChange(v, k) {
    this.setState({ [k]: v })
  }

  isFormValid() {
    let { mainCategory, subCategory, firstName, lastName, email, phoneNumber, message, cboxAccepted } = this.state
    if (mainCategory && subCategory && firstName && lastName && isValidEmail(email) && phoneNumber.length == 12 && message && (cboxAccepted || this.props.user.user)) {
      return true
    }
    return false
  }

  async publishCustomerInfo() {
    this.setState({ loadingSend: true })
    let { mainCategory, subCategory, firstName, lastName, email, phoneNumber, message } = this.state
    let params = {
        mainCategory,
        subCategory,
        firstName,
        lastName,
        email,
        phoneNumber,
        message
    }
    try{
        let submitresp = await  submitContactForm(params)
        this.setState({showThanksModal: true,modalText:submitresp?.data?.message})
        this.clearState()
    }
    catch{
        this.setState({ loadingSend: false })
    }
  }

  setQuestionIndex(idx) {
    if (this.state.selectedQuestionIndex == idx) {
      this.setState({ selectedQuestionIndex: null })
      return
    }
    this.setState({ setSelectedQuestionIndex: idx });
  }

  search = (term) => {
    let trEn = getLocale(this.props)
    let termLowerCase = term.toLowerCase()
    let allQuestions = SSS_CONTENTS.map(h => h.questions)
    let foundItems = []
    allQuestions.forEach(aq => {
      aq.forEach(item => {
        if (item.question[trEn].indexOf(term) >= 0 || item.question[trEn].toLowerCase().indexOf(termLowerCase) >= 0 || item.answer[trEn].indexOf(term) >= 0 || item.answer[trEn].toLowerCase().indexOf(termLowerCase) >= 0) foundItems.push(item)
      })
    })

    this.setState({ searchResults: foundItems });
  }

  render() {
    let _state = { ...this.props }
    let trEn = getLocale(_state)

    return (
      <div>
        <div>
          <SBheader />
          <main className="sb-contact height-100 flex flex-column">
            <div className="sb-headerCrate flex flex-column bg-white  flex-shrink-none">
              <div className="flex flex-grow flex-column ">
                <div className="container--headerCrate sb-headerCrate--content size12of12 ">
                  <h1 className="sb-heading sb-heading--large text-bold" style={{ lineHeight: "36px" }} tabIndex={-1}>{TEXTS.contact_us[trEn]}</h1></div>
              </div>
            </div>
            <div id="searchInput" className="sb-contentCrate flex-grow sb-contact">
              <div className="relative flex-auto">
                <div className="help-capsul">
                  <div className="help-head">
                    <div className="help-bar">
                      <div className="search-icon">
                        <svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                          <title>Shape</title>
                          <g id="Phase-3" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                            <g id="02.01---Anasayfa--(Kullanıcı)" transform="translate(-598.000000, -241.000000)" fill="#062819" fillRule="nonzero">
                              <g id="body" transform="translate(0.000000, 103.000000)">
                                <g id="slider-ve-tarih-seçimleri" transform="translate(88.000000, 0.000000)">
                                  <g id="left" transform="translate(0.000000, 62.000000)">
                                    <g id="arama" transform="translate(0.000000, 54.000000)">
                                      <path d="M518.042521,22 C522.487795,22 526.085042,25.4959473 526.085042,29.8160419 C526.085042,31.2759325 525.635024,32.7341673 524.783356,34.0367766 L524.718967,34.1307618 L529.716127,38.3877951 C530.009877,38.7140555 530.085235,39.1609181 529.897103,39.512838 L529.844555,39.5987152 L529.780871,39.6798881 C529.451314,40.0459176 528.890372,40.0978877 528.497074,39.8366172 L528.415508,39.7758365 L523.492818,35.5599856 L523.432549,35.6165567 C522.111932,36.7907144 520.364021,37.5033087 518.550746,37.616245 L518.291301,37.6282845 L518.042521,37.6320838 C513.629618,37.6320838 510,34.1046765 510,29.8160419 C510,25.4959473 513.597246,22 518.042521,22 Z M518.010149,23.6952741 C514.524367,23.6952741 511.712025,26.4284201 511.712025,29.8160419 C511.712025,33.2036637 514.524367,35.9368098 518.010149,35.9368098 C521.495931,35.9368098 524.308273,33.2036637 524.308273,29.8160419 C524.308273,26.4284201 521.495931,23.6952741 518.010149,23.6952741 Z" id="Shape" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <input onChange={(e) => { this.setState({ searchTerm: e.target.value }); this.search(e.target.value); }} value={this.state.searchTerm} type="text" placeholder={trEn == "tr" ? "Sıkça sorulan sorular arasında arama yapın" : "Search..."} />
                    </div>
                  </div>
                  <div className="help-container">

                    <div className="help-category">
                      {
                        SSS_CONTENTS.map((c, i) =>
                          <div onClick={() => { this.setState({ selectedContentId: c.id }); this.setState({ selectedQuestionIndex: null }); this.setState({ searchTerm: "" }); }} key={c.id} className="help-category-item">
                            <span style={{padding:0}}>{c.title[trEn]}</span>
                          </div>)
                      }
                      <div className="help-category-item"
                        onClick={() => window.open("/help")}
                      >
                        <span>{"STARBUCKS MOBIL UYGULAMASI"}</span>
                      </div>
                    </div>

                    <div className="help-list">
                      {this.state.selectedContentId && this.state.searchTerm.length < 3 && this.state.selectedContentId != "contactUs" &&
                        SSS_CONTENTS.find(c => c.id == this.state.selectedContentId)?.questions.map((q, idx) =>
                          <div key={idx} className="help-list-item">
                            <div onClick={() => { this.setState({selectedQuestionIndex: idx}); }} className="help-list-item-head">
                              <span>{q.question[trEn]}</span>
                              <svg viewBox="0 0 24 24" className={"valign-middle accordion_heading__QxJIo inline-block ml3 flex-shrink-none self-center accordion_caret__NT6wl"} preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false" style={{ width: '24px', height: '24px', overflow: 'visible', fill: 'currentColor' }}><path d="M11.96 15.5c-.206 0-.402-.084-.546-.232l-5.188-5.33c-.3-.31-.3-.81 0-1.12.3-.31.79-.31 1.093 0l4.64 4.767 4.723-4.853c.3-.31.79-.31 1.09 0 .303.31.303.812.002 1.122l-5.27 5.414c-.145.148-.34.232-.546.232" /></svg>
                            </div>
                            <div className="help-list-item-content" style={{ display: this.state.selectedQuestionIndex == idx ? "block" : "none" }}>
                              <p dangerouslySetInnerHTML={{ __html: q.answer[trEn] }}></p>         
                            </div>
                          </div>
                        )}

                      {this.state.searchTerm.length >= 3 &&
                        this.state.searchResults?.map((q, idx) =>
                          <div key={idx} className="help-list-item">
                            <div onClick={() => { this.setState({selectedQuestionIndex: idx})}} className="help-list-item-head">
                              <span>{q.question[trEn]}</span>
                              <svg viewBox="0 0 24 24" className={"valign-middle accordion_heading__QxJIo inline-block ml3 flex-shrink-none self-center accordion_caret__NT6wl"} preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false" style={{ width: '24px', height: '24px', overflow: 'visible', fill: 'currentColor' }}><path d="M11.96 15.5c-.206 0-.402-.084-.546-.232l-5.188-5.33c-.3-.31-.3-.81 0-1.12.3-.31.79-.31 1.093 0l4.64 4.767 4.723-4.853c.3-.31.79-.31 1.09 0 .303.31.303.812.002 1.122l-5.27 5.414c-.145.148-.34.232-.546.232" /></svg>
                            </div>
                            <div className="help-list-item-content" style={{ display: this.state.selectedQuestionIndex == idx ? "block" : "none" }}>
                              <p>
                                <Highlighted text={q.answer[trEn]} highlight={this.state.searchTerm}/>
                              </p>
                            </div>
                          </div>
                        )}

                      {this.state.selectedContentId == "contactUs" && this.state.searchTerm.length < 3 &&
                        <>
                          <div className="help-list-item">
                            <div className="help-list-item-head">
                              <span>
                                <span>
                                  <span className>{"STARBUCKS MOBİL HAKKINDA"}</span>
                                </span>
                              </span>
                            </div>
                            <div className="help-list-item-content" style={{ display: 'block' }}>
                              {trEn == "tr" ?

                                <>
                                  <p>

                                    <b>Starbucks Card İletişim Hattı:</b>
                                    <br />
                                    0850 800 07 29
                                    <br />
                                    <br />
                                    <b>Mail Adresimiz:</b>
                                    <br />
                                    starbucks-tr-app@alshaya.com
                                  </p>
                                </>
                                :
                                <>
                                  <p>
                                    <b>Starbucks Card Contact Number:</b>
                                    <br />
                                    0850 800 07 29
                                    <br />
                                    <br />
                                    <b>Email address:</b>
                                    <br />
                                    starbucks-tr-app@alshaya.com
                                  </p>
                                </>
                              }
                            </div>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative flex-auto">
                <div className="flex-auto">
                  <div className="sb-contentColumn mx-auto sb-contentColumn--narrow px0">
                        <>
                          <div className="flex">
                            <div className="inform-head">
                              <h2>{this.state.contactForm.firstTitle}</h2>
                              <p>Merhaba, Starbucks'a hoş geldiniz. Nasıl yardımcı olabiliriz? Sorularınız için öncelikle <a href="#searchInput" style={{ textDecoration: 'underline', textDecorationColor: '#006341', color: 'green', cursor: 'pointer' }}>Sıkça Sorulan Sorular</a> bölümünü de ziyaret etmenizi öneririz
                                <br /><br />
                                Geri bildirimleriniz bizim için değerlidir. Görüşleriniz size sunduğumuz Starbucks deneyimini mükemmel hale getirmemize yardımcı oluyor.
                              </p>
                              
                              <img className="detail-bg" src="https://content.sbuxtr.com/images/ui/1700x560-gorsel-store.jpg" />
                              
                              <br /><br />
                              <h2>{this.state.contactForm.secondTitle}</h2>
                              <p><span className="dot" style={{ width: '15px', height: '15px', backgroundColor: 'black', display: 'block', borderRadius: '50%', position: 'absolute', marginLeft: '-25px', marginTop: '4px' }} />
                                {this.state.contactForm.secondDescription}
                                <br/><br/>
                              </p>
                            </div>
                          </div>
                        </>

                    <div className="flex">
                      <div className="contact-form">
                        <fieldset className="pb6">
                          <Select2 onChange={(e) => {
                            this.setState({ mainCategory: e.target.value, subCategory: "" }

                            )
                          }} label={TEXTS.main_category[trEn] + " *"}
                            value={this.state.mainCategory}>
                            {this.state.contactForm.categoryLabel?.map((c,i)=>
                                <option key={i} value={c.categoryName}>{c.mainCategoryLabel?.categoryName}</option>)}
                          </Select2>
                        </fieldset>
                        <fieldset className="pb6">
                          <Select2 onChange={(e) => { this.setState({ subCategory: e.target.value }) }} label={TEXTS.sub_category[trEn] + " *"}
                            value={this.state.subCategory}>
                             {this.state.contactForm.categoryLabel?.find(c=>c.mainCategoryLabel.categoryName==this.state.mainCategory)
                                    ?.subCategoryLabel.map((c,i)=>
                                    <option key={i} value={c.subCategoryName}>{c.subCategoryName}</option>)
                                }
                          </Select2>
                        </fieldset>

                        <fieldset className="pb6">
                          <Field value={this.state.firstName} valueChanged={(e) => { this.handleFormChange(e, "firstName") }} id='a3' error={!this.state.firstName} errorMessage={TEXTS.warning_enteryourfirstname[trEn]} >
                            {TEXTS.name[trEn]} *
                          </Field>
                        </fieldset>

                        <fieldset className="pb6">
                          <Field value={this.state.lastName} valueChanged={(e) => { this.handleFormChange(e, "lastName") }} id='a4' error={!this.state.lastName} errorMessage={TEXTS.warning_enteryoursurname[trEn]}>
                            {TEXTS.surname[trEn]} *
                          </Field>
                        </fieldset>

                        <fieldset className="pb6">
                          <Field value={this.state.email} valueChanged={(e) => { this.handleFormChange(e, "email") }} id='a5' error={!isValidEmail(this.state.email)} errorMessage={TEXTS.warning_entervalidemail[trEn]}>
                            E-mail *
                          </Field>
                        </fieldset>

                        <fieldset className="pb6">
                          <Field value={this.state.phoneNumber} 
                                 valueChanged={(e) => { 
                                  if (e.startsWith("90") && isNumericOrEmpty(e) && e.length <= 12) this.handleFormChange(e, "phoneNumber") 
                                }} 
                                 id='a6' error={this.state.phoneNumber.length < 12} errorMessage={TEXTS.warning_entervalidphonenumber[trEn]} >
                            {TEXTS.phoneNumber[trEn]} *
                          </Field>
                        </fieldset>

                        <fieldset className="pb6 msgBox">

                          <textarea placeholder={TEXTS.Message[trEn]} value={this.state.message} onChange={(e) => { this.handleFormChange(e.target.value, "message") }} rows="2" cols="60">

                          </textarea>
                        </fieldset>

                        {!this.props.user.user &&
                          <div className="aggr-mp form-item">
                            <p className="txt">{this.state.contactForm.kvkkDescription}</p>

                            <Checkbox value={this.state.cboxAccepted} valueChanged={v => { this.setState({ cboxAccepted: v }) }}>
                                {this.state.contactForm.kvkkLabel?.kvkkCheckboxDescription}
                            </Checkbox>
                            {trEn == "tr" &&
                              <p className="mb3">
                                <span onClick={() => { var win = window.open(this.state.contactForm.linkLabel?.linkContent, '_blank'); win.focus() }} style={{ textDecoration: "underline", textDecorationColor: "#006341", color: "green", cursor: "pointer" }}>
                                  {this.state.contactForm.linkLabel?.linkText}
                                </span>
                              </p>}
                          </div>}
                        <div className="flex justify-end btns">
                          <div className="activateBtn">
                            <Frap onClick={() => { this.publishCustomerInfo() }} disabled={!this.isFormValid()}
                              loading={this.state.loadingSend}
                              className='mr3 mb4'>
                              {TEXTS.send[trEn]}
                            </Frap>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='flex' style={{ marginTop: "50px" }}>
                      <h4>Veya,</h4>
                    </div>
                    <div className='flex' style={{ marginTop: "10px" }}>
                      <p><span className="dot" style={{ width: '15px', height: '15px', backgroundColor: 'black', display: 'block', borderRadius: '50%', position: 'absolute', marginLeft: '-25px', marginTop: '4px' }} />Starbucks Mobil Uygulama ve Reward Programı ile ilgili konularda (Uygulama deneyimi, kampanyalar, bakiye yükleme, yıldız kazanma/harcama, deaktive hataları) gibi uygulama ile ilgili, konularda bize en hızlı ulaşmak için lütfen <a href="mailto:starbucks-tr-app@alshaya.com">starbucks-tr-app@alshaya.com</a> adresine mail atınız veya <a href='tel:08508000729'>0850 800 0729</a> numaralı (hafta içi 09:00 – 21:00 saatleri arasında) iletişim hattımızdan arayabilirsiniz.</p>
                    </div>

                    <div className='flex'>
                      <p><span className="dot" style={{ width: '15px', height: '15px', backgroundColor: 'black', display: 'block', borderRadius: '50%', position: 'absolute', marginLeft: '-25px', marginTop: '4px' }} />Markamızla ilgili diğer tüm soru, görüş ve geri bildirimleriniz için bize; <br /> <a href="mailto:infostarbucks-tr@alshaya.com">infostarbucks-tr@alshaya.com</a> adresinden veya 44 44 SHY / 44 44(749) numaralı (haftaiçi 08:00 – 17:00 saatleri arasında) iletişim hattımızdan ulaşabilirsiniz.</p>
                    </div>
                  </div>
                </div>
              </div>
              <style dangerouslySetInnerHTML={{ __html: "\n.sb-new-footer{\n\t    clip-path: inset(0px 0px 0px 2px);\n        box-shadow: 0 0 2px 0 rgb(0 0 0 / 24%), 0 4px 4px 0 rgb(0 0 0 / 12%);\n}\n<style>\n" }} />
              <SBnewFooter />
            </div>
          </main>
        </div>
        {this.state.showThanksModal &&
          <SBsimpleModal titleText={this.state.modalText}
            btn1Text={TEXTS.ok[trEn]} onClickBtn1={() => { this.setState({ showThanksModal: false }) }}
          />}
      </div>
    )
  }
}

const Highlighted = ({text = '', highlight = ''}) => {
  if (!highlight.trim()) {
    return <span>{text}</span>
  }
  const regex = new RegExp(`(${_.escapeRegExp(highlight)})`, 'gi')
  const parts = text.split(regex)
  return (
    <span>
       {parts.filter(part => part).map((part, i) => (
           regex.test(part) ? <mark key={i}>{part}</mark> : <span key={i}>{part}</span>
       ))}
   </span>
  )
}

function mapDispatchToProps(dispatch) {
  return ({
  })
}
function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Contact))
